import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import SimpleBlock from '../Block'

const TitleBlock = (props: IBlockProps): ReactElement => (
  <SimpleBlock {...props} translation={props.translation?.toLocaleUpperCase()} type="title" />
)

export default TitleBlock
